import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
	faBars,
	faCalendarDays,
	faChevronDown,
	faEnvelope,
	faPhone,
	faChevronUp,
	faGlobe,
	faTimes,
	faShower,
	faBath,
	faWifi,
	faMugHot,
	faFireplace,
	faTv,
	faVault,
	faPlateUtensils,
	faRefrigerator,
	faBlanket,
} from '@fortawesome/pro-light-svg-icons';

import {
	faFacebook,
	faInstagram,
	faLinkedin,
	faPinterest,
	faSoundcloud,
	faSpotify,
	faTiktok,
	faTwitter,
	faWhatsapp,
	faYoutube,
	faXTwitter,
} from '@fortawesome/free-brands-svg-icons';

import {
	faArrows,
	faEuroSign,
	faMinus,
	faPlay,
	faPlus,
	faSearch,
	faStar,
	faQuoteLeft,
	faStarHalf,
	faUsers,
} from '@fortawesome/pro-solid-svg-icons';

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false;

library.add(
	faArrows,
	faBars,
	faShower,
	faBath,
	faWifi,
	faTv,
	faVault,
	faPlateUtensils,
	faRefrigerator,
	faBlanket,
	faChevronUp,
	faChevronDown,
	faCalendarDays,
	faEnvelope,
	faEuroSign,
	faGlobe,
	faQuoteLeft,
	faMugHot,
	faFireplace,
	faFacebook,
	faInstagram,
	faLinkedin,
	faMinus,
	faPinterest,
	faPhone,
	faPlay,
	faPlus,
	faSearch,
	faSoundcloud,
	faSpotify,
	faTiktok,
	faTwitter,
	faUsers,
	faWhatsapp,
	faYoutube,
	faStar,
	faStarHalf,
	faTimes,
	faXTwitter,
);

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('font-awesome-icon', FontAwesomeIcon, {});
});
